import { render, staticRenderFns } from "./ClientEdit.vue?vue&type=template&id=5b79159e&scoped=true"
import script from "./ClientEdit.vue?vue&type=script&setup=true&lang=js"
export * from "./ClientEdit.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b79159e",
  null
  
)

export default component.exports